import { typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const BlobContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const BlobTextWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const BlobTitleStyled = styled.b`
  ${typography.bold[16]}
  white-space: nowrap;
`;

export const BlobTextStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
`;
